import React from 'react';
import './carousel.scss';
import PropTypes from 'prop-types';
import { CarouselItem } from './CarouselItem';

export const Carousel = ({ activeIndex, className, children }) => {
    const normalizedActiveIndex = activeIndex % children.length;
    const carouselClassName = `carousel ${className ?? ''}`;
    const getCarouselItemkey = childKey => `carousel_${childKey}`;

    const drawChildren = () =>
        React.Children.map(children, (child, index) => {
            return (
                <CarouselItem
                    currentIndex={normalizedActiveIndex}
                    isActive={index === normalizedActiveIndex}
                    key={getCarouselItemkey(child.key)}
                >
                    {child}
                </CarouselItem>
            );
        });

    return <div className={carouselClassName}>{drawChildren()}</div>;
};
Carousel.propTypes = {
    activeIndex: PropTypes.number.isRequired,
    className: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.node).isRequired,
};
